import React from 'react';

const DropdownCell = ({ value, options, onChange, required = false, fieldName, rowId }) => {
  const selectId = `${fieldName?.toLowerCase()}-${rowId}`;
  const errorId = `${selectId}-error`;
  const hasError = required && !value;
  
  const handleKeyDown = (e) => {
    if (e.ctrlKey && e.key === 'a') {
      e.target.select();
    }
  };

  return (
    <div className="relative">
      <select
        id={selectId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        className={`w-full px-3 py-2 border-2 rounded-lg text-xs font-medium transition-all duration-200 focus:outline-none focus:ring-4 ${
          hasError
            ? 'border-red-400 bg-red-50 text-red-800 focus:ring-red-200 focus:border-red-600' 
            : 'border-gray-300 bg-white hover:border-gray-400 focus:ring-blue-200 focus:border-blue-600 focus:bg-blue-50'
        }`}
        aria-label={`${fieldName} for row ${rowId}`}
        aria-required={required}
        aria-invalid={hasError}
        aria-describedby={hasError ? errorId : undefined}
      >
        <option value="">Choose {fieldName}...</option>
        {options.map(option => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
      {hasError && (
        <div id={errorId} className="sr-only" role="alert">
          {fieldName} is required
        </div>
      )}
    </div>
  );
};

export default DropdownCell;